import { render, staticRenderFns } from "./UpdateBuyersInfoForm.vue?vue&type=template&id=4a1a738c&scoped=true"
import script from "./UpdateBuyersInfoForm.vue?vue&type=script&lang=js"
export * from "./UpdateBuyersInfoForm.vue?vue&type=script&lang=js"
import style0 from "./UpdateBuyersInfoForm.vue?vue&type=style&index=0&id=4a1a738c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1a738c",
  null
  
)

export default component.exports